(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kn-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = () => {
    document.querySelectorAll('.kn-home').forEach((root) => {
      if (root.dataset.knMotionReady) return;
      root.dataset.knMotionReady = 'true';
      if (!('IntersectionObserver' in window) || !('animate' in Element.prototype)) return;
      const active = new Set();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          if (preference.matches) return;
          const siblings = Array.from(entry.target.parentElement.children);
          const delay = entry.target.matches('.kn-category, .kn-product')
            ? Math.min(siblings.indexOf(entry.target), 3) * 70
            : 0;
          const animation = entry.target.animate(
            [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 650, delay, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'backwards' }
          );
          active.add(animation);
          animation.finished.then(() => active.delete(animation)).catch(() => active.delete(animation));
        });
      }, { threshold: 0.08 });
      root.querySelectorAll('.kn-category, .kn-product, .kn-custom-copy, .kn-custom-photo').forEach((element) => observer.observe(element));
      const reduceMotion = () => {
        if (preference.matches) active.forEach((animation) => animation.cancel());
      };
      preference.addEventListener('change', reduceMotion);
      root.addEventListener('shopify:section:unload', () => {
        observer.disconnect();
        active.forEach((animation) => animation.cancel());
        preference.removeEventListener('change', reduceMotion);
      }, { once: true });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
